export default __webpack_public_path__ + "static/media/icons8-soldering-iron.13b372b7.svg";